import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, BasicApiResponseModel, ApiVisa, Pagination, PagingResponseModel} from '../../shared';
import {PriceBookContainerModel} from '../../../../../../models/aggregates/erp/price-book';
import {Core2Config} from '../../shared';
import {Observable} from 'rxjs';
import {bl_fi_mst_price_book_line_RowClass} from '../../../../../../models/dbschema';

@Injectable({
  providedIn: 'root'
})
export class PriceBookService extends BaseApiTemplateService<PriceBookContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricebooks';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricebooks';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricebooks';
    this.httpClient = http;
  }

  public postPrice(dtoObject: PriceBookContainerModel, visa: ApiVisa
    ): Observable<BasicApiResponseModel<PriceBookContainerModel>> {
      return this.httpClient.post<BasicApiResponseModel<PriceBookContainerModel>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

  public getLine(visa: ApiVisa): Observable<BasicApiResponseModel<bl_fi_mst_price_book_line_RowClass>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<bl_fi_mst_price_book_line_RowClass>>(
      this.apiUrl + '/lines',
      this.getHttpHeader(visa)
    );
  }

  public getByGuidLine(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<bl_fi_mst_price_book_line_RowClass>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<bl_fi_mst_price_book_line_RowClass>>(
      this.apiUrl + '/lines/' + guid,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaLine(pagination: Pagination, visa: ApiVisa):
    Observable<PagingResponseModel<bl_fi_mst_price_book_line_RowClass>> {
    let url = this.apiUrl + '/lines/'  + 'query?' + pagination.getQueryKeyValues();
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/lines/'  + 'query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<bl_fi_mst_price_book_line_RowClass>>
    (url, this.getHttpHeader(visa));
  }

  getByCriteriaWebsiteEp(
    pagination: Pagination,
    visa: ApiVisa,
    websiteHdrGuid: string,
  ): Observable<PagingResponseModel<PriceBookContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + `/website-ep/${websiteHdrGuid}/query` + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PriceBookContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }


}


